import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';

const ContactForm = () => {
    const [phone, setPhone] = useState('');
    const [status, setStatus] = useState('idle'); // idle | submitting | success | error

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('submitting');

        const formData = new FormData(e.target);
        formData.append('phone', phone);

        try {
            const res = await fetch('https://formspree.io/f/xvzynyyy', {
                method: 'POST',
                body: formData,
                headers: { Accept: 'application/json' },
            });

            if (res.ok) {
                setStatus('success');
                e.target.reset();
                setPhone('');
            } else {
                setStatus('error');
            }
        } catch {
            setStatus('error');
        }
    };

    if (status === 'success') {
        return (
            <div className="p-4 bg-white text-center py-5">
                <div className="mb-3" style={{ fontSize: '2.5rem' }}>✓</div>
                <h5 className="fw-bold mb-2">Message received!</h5>
                <p className="text-muted">We usually respond within 24–48 hours.</p>
                <button
                    className="btn btn-outline-secondary rounded-pill px-4 mt-2"
                    onClick={() => setStatus('idle')}
                >
                    Send another message
                </button>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit} className="p-4 bg-white">

            {/* Full Name */}
            <div className="mb-4">
                <label className="form-label fw-semibold text-secondary">Full Name*</label>
                <input
                    type="text"
                    name="name"
                    className="form-control form-control-lg fs-6 py-3"
                    placeholder="Enter your full name"
                    required
                />
            </div>

            <div className="row">
                {/* Email */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold text-secondary">Email*</label>
                    <input
                        type="email"
                        name="email"
                        className="form-control form-control-lg fs-6 py-3"
                        placeholder="Enter your email"
                        required
                    />
                </div>

                {/* Contact No */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold text-secondary">Contact No.*</label>
                    <PhoneInput
                        country={'in'}
                        value={phone}
                        onChange={setPhone}
                        inputStyle={{
                            width: '100%',
                            height: '58px',
                            fontSize: '1rem',
                            borderRadius: '0.375rem'
                        }}
                        buttonStyle={{
                            backgroundColor: 'transparent',
                            borderRight: 'none',
                            borderRadius: '0.375rem 0 0 0.375rem'
                        }}
                        placeholder="Enter your contact no"
                    />
                </div>
            </div>

            {/* Message */}
            <div className="mb-4">
                <label className="form-label fw-semibold text-secondary">Message</label>
                <textarea
                    name="message"
                    className="form-control fs-6"
                    rows="5"
                    placeholder="Enter your main text here..."
                ></textarea>
            </div>

            {status === 'error' && (
                <p className="text-danger small mb-3">
                    Something went wrong — please try again.
                </p>
            )}

            {/* Footer Section */}
            <div className="d-flex justify-content-between mt-4 align-items-center">
                <small className="text-muted mb-0">
                    We usually respond within 24–48 hours.
                </small>
                <button
                    type="submit"
                    disabled={status === 'submitting'}
                    className="btn px-5 py-2 fw-bold"
                    style={{
                        borderRadius: '50px',
                        border: '2px solid #5d5fef',
                        color: '#333',
                        letterSpacing: '1px',
                        fontSize: '0.9rem',
                        opacity: status === 'submitting' ? 0.7 : 1,
                    }}
                >
                    {status === 'submitting' ? 'SENDING…' : 'SEND MESSAGE'}
                </button>
            </div>
        </form>
    );
};

export default ContactForm;
